import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { wrapDisplayName } from '../displayName';
import { jsx as _jsx } from "react/jsx-runtime";
export function withoutBodyOverflow(WrappedComponent, displayName) {
  var Component = /*#__PURE__*/function (_React$Component) {
    function Component() {
      _classCallCheck(this, Component);
      return _callSuper(this, Component, arguments);
    }
    _inherits(Component, _React$Component);
    return _createClass(Component, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        document.body.style.overflow = 'hidden';
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.body.style.overflow = '';
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_jsx(WrappedComponent, _objectSpread({}, this.props));
      }
    }]);
  }(React.Component);
  Component.displayName = displayName || wrapDisplayName(Component, 'withoutBodyOverflow');
  return Component;
}